import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { APP_PATHS } from '@/app/utils';

export const UserGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  return authService.tryRestoreSession().pipe(
    map((restored) => (restored ? true : router.createUrlTree([APP_PATHS.LOGIN])))
  );
};
